/**
 * User-facing copy for OMS / inventory API `code` values (modal, inline alerts).
 * Same pattern as Admin Portal `getFriendlyErrorMessage` (map lookup + fallback).
 * Sourced from SHARED_ORDER_MUTATION_ENTRIES for consistency with alert banner.
 */

import { isOrderMutationErrorCode } from "../enums/orderMutationErrorCode";
import { SHARED_ORDER_MUTATION_ENTRIES } from "../constants/orderMutationMessageEntries";

const ORDER_MUTATION_MESSAGES = SHARED_ORDER_MUTATION_ENTRIES;

export function messageForOrderMutationCode(
  code: string,
  t: (key: string, defaultValue: string) => string
): string {
  if (isOrderMutationErrorCode(code)) {
    const entry = ORDER_MUTATION_MESSAGES[code];
    return t(entry.translationKey, entry.value);
  }
  return t(
    "order-error-with-code",
    `Could not complete the request (${code}).`
  );
}
